import React, { Component } from 'react'
import { connect } from 'react-redux'
import { do_action } from '../../actions'
import {BASE_URL_ADMIN} from '../../data/config'
import ModalAddItemDesigner from '../Modal/ModalAddItemDesigner'
import {convertPriceNumber, getTimePDF, convertPriceToNumber} from '../../utils/convert'

class DesignerItemQuote extends Component {
    constructor(props) {
        super(props)
        this.state = {
            quoteDesignerItems: [],
            itemAdd: [],
            nb_add: 1,
            dataCategory: {}
        }
    }

    componentWillMount() {
        do_action('get_quote_designer_items', { vendor: this.props.vendor._id, quote: this.props.quote })
            .then(data => {
                if (data.signal) {
                    let {allCategory, allItems} = data.data
                    let dataCategory = {}
                    allCategory.map(cat => {
                        dataCategory[cat._id] = cat.name
                    })

                    let itemAdd = allItems.map(it => {
                        return it.item._id
                    })
                    this.setState({
                        quoteDesignerItems: allItems,
                        itemAdd,
                        dataCategory
                    })
                }
            })
            .catch(err => console.log(err));
        
    }

    addNewQuoteDesignerItem = (data) => {
        let {
            quoteDesignerItems,
            itemAdd
        } = this.state;
        quoteDesignerItems.push(data);
        itemAdd.push(data.item._id)
        this.setState({
            quoteDesignerItems,
            itemAdd
        });
    }

    removeQuoteDesignerItem = (id, item_id) => {
        if (window.confirm('Are you sure to remove this item')) {
            do_action('remove_quote_designer_item', { id })
                .then(data => {
                    if (data.signal) {
                        let itemAdd = this.state.itemAdd.filter(e => e != item_id)
                        let newQuoteDesignerItems = this.state.quoteDesignerItems.filter(e => e._id !== id);
                        this.setState({ 
                            quoteDesignerItems: newQuoteDesignerItems,
                            itemAdd 
                        });
                    } else alert('Something went wrong');
                })
                .catch(err => console.log(err));
        }
    }

    renderQuoteDesignerItems = () => {
        let {quoteDesignerItems, dataCategory} = this.state

        return quoteDesignerItems.map((item) => {
            let category_id = item.item.category_id || ''
            let category = dataCategory[category_id] || ''
            return (
                <div key={item._id}>
                    <div className="clearfix form-group">
                        <div className="pull-left resis-left">
                            <h4 className="fontMedium marginT0">{item.item.title}</h4>
                            <h6>Group: {category}</h6>
                        </div>
                        <div className="pull-right resis-right">
                            <h4 className="text-primary-kt text-right fontMedium marginT0">${convertPriceNumber(item.item.price)}/{item.item.type_price}</h4>
                            <h6 className="text-primary-kt text-right fontMedium">x{item.quantity} {item.item.type_price}</h6>
                            {this.props.quoteState == 0 && (
                                <h6 className="text-right">
                                    <a href="#" className="remove" onClick={this.removeQuoteDesignerItem.bind(this, item._id, item.item._id)}>Remove</a>
                                </h6>
                            )}
                            
                        </div>
                    </div>
                </div>
            )
        })
    }

    // printQuotes() {
    //     var pwa = window.open("", "_new");
    //     pwa.document.open();
    //     pwa.document.write(this.pageToPrint());
    //     pwa.document.close();
    // }

    // pageToPrint() {
    //     let {vendor} = this.props
    //     let {quoteDesignerItems} = this.state

    //     let price_total = 0;
    //     let contentItem = quoteDesignerItems.map((item, idx) => {
    //         let total_price = parseFloat(item.quantity) * parseFloat(item.item.price)
    //         price_total += total_price
    //         return `
    //             <tr>
    //                 <th class="text-center">${idx + 1}</th>
    //                 <td>${items.item.title}</td>
    //                 <td class="text-center">${items.quantity} ${item.item.type_price}</td>
    //                 <td class="text-right">$${convertPriceNumber(total_price)}</td>
    //             </tr>
    //         `
    //     });

    //     let customer = customer =  {first_name: '', last_name: '', phone: '', address:'', city: ''}
    //     let windowContent =
    //         `<!DOCTYPE html>
    //         <html lang="en">
            
    //         <head>
    //             <meta charset="utf-8">
    //             <meta http-equiv="X-UA-Compatible" content="IE=edge">
    //             <meta name="viewport" content="width=device-width, initial-scale=1">
    //             <title>Quote detail</title>
    //             <style>
    //             @media print {
    //                 @page {
    //                     margin: 0 auto; /* imprtant to logo margin */
    //                     sheet-size: 80mm 250mm; /* imprtant to set paper size */
    //                 }
    //                 html,body{margin:0;padding:0;}
    //                 #printContainer {
    //                     width: 230px;
    //                     margin: auto;
    //                     padding: 5px;
    //                     /*border: 2px dotted #000;*/
    //                     text-align: justify;
    //                     font-family: GillSansStd;
    //                 }
    //                 #logo{
    //                     margin: 0 5px;

    //                 }

    //                 .tr-special {
    //                     background: transparent !important;
    //                     border: none !important;
    //                 }
    //                 .tr-special .all-price {
    //                     padding: 4px 4px;
    //                     border-top: 1px solid #ccc;
    //                     border-bottom: 1px solid #ccc;
    //                 }
    //                 .text-red {
    //                     color: red;
    //                 }

    //                 .text-center{text-align: center;}
    //                 .text-right{text-align: right;}
    //                 .text-left{text-align: left;}
    //             }
    //                 .marginB5 { margin-bottom: 5px; }
            
    //                 .border-top { border-top: 1px solid #ccc; }
            
    //                 .text-underline { text-decoration: underline; }
            
    //                 .text-red { color: red; }
            
    //                 .header { padding: 30px 0 0 0; }
    //                 .header .sub-logo { color: #a2a2a2; font-size: 12px; margin: 10px 0 0 0; }
    //                 .header .address { font-size: 13px; color: red; border-bottom: 2px solid #ababab; padding-bottom: 10px; margin-bottom: 10px; }
            
    //                 .attn { display: inline-block; width: 100px; }
            
    //                 .tr-special { background: transparent !important; border: none !important; }
    //                 .tr-special td { border: none !important; padding-top: 25px !important; }
    //                 .tr-special .all-price { padding: 4px 4px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; }
            
    //                 .table-kentrung { border: none; border-top: 1px solid #ccc; }

    //                 p {
    //                     margin: 0 0 10px;
    //                 }
                    
    //                 .container {
    //                     padding-right: 15px;
    //                     padding-left: 15px;
    //                     margin-right: auto;
    //                     margin-left: auto;
    //                     width: 1050px;
    //                 }
                    
    //                 .text-center {
    //                     text-align: center;
    //                 }
                    
    //                 .row {
    //                     margin-right: -15px;
    //                     margin-left: -15px;
    //                 }
                    
    //                 .table-bordered {
    //                     border: 1px solid #ddd;
    //                 }
            
    //                 .table {
    //                     width: 100%;
    //                     max-width: 100%;
    //                     margin-bottom: 20px;
    //                 }
    //                 table {
    //                     background-color: transparent;
    //                 }
    //                 table {
    //                     border-spacing: 0;
    //                     border-collapse: collapse;
    //                 }
                    
    //                 .text-right {
    //                     text-align: right;
    //                 }
                    
    //                 .col-lg-4 {
    //                     width: 33.33333333%;
    //                 }
                    
    //                 .col-lg-push-4 {
    //                     left: 33.33333333%;
    //                 }
                    
    //                 * {
    //                     -webkit-box-sizing: border-box;
    //                     -moz-box-sizing: border-box;
    //                     box-sizing: border-box;
    //                 }
                    
    //                 .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9 {
    //                     float: left;
    //                 }
                    
    //                 .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
    //                     position: relative;
    //                     min-height: 1px;
    //                     padding-right: 15px;
    //                     padding-left: 15px;
    //                 }
                    
    //                 .table>caption+thead>tr:first-child>td, .table>caption+thead>tr:first-child>th, .table>colgroup+thead>tr:first-child>td, .table>colgroup+thead>tr:first-child>th, .table>thead:first-child>tr:first-child>td, .table>thead:first-child>tr:first-child>th {
    //                     border-top: 0;
    //                 }
            
    //                 .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    //                     border-bottom-width: 2px;
    //                 }
    //                 .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    //                     border: 1px solid #ddd;
    //                 }
                    
    //                 .table-striped>tbody>tr:nth-of-type(odd) {
    //                     background-color: #f9f9f9;
    //                 }
                    
    //                 .table>thead>tr>th {
    //                     vertical-align: bottom;
    //                     border-bottom: 2px solid #ddd;
    //                 }
    //                 .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    //                     padding: 8px;
    //                     line-height: 1.42857143;
    //                     vertical-align: top;
    //                     border-top: 1px solid #ddd;
    //                 }
    //                 th {
    //                     text-align: left;
    //                 }
    //                 .container:after,.container:before,.row:after,.row:before {
    //                     display: table;
    //                 }
    //                 .btn-group-vertical>.btn-group:after, .btn-toolbar:after, .clearfix:after, .container-fluid:after, .container:after, .dl-horizontal dd:after, .form-horizontal .form-group:after, .modal-footer:after, .modal-header:after, .nav:after, .navbar-collapse:after, .navbar-header:after, .navbar:after, .pager:after, .panel-body:after, .row:after {
    //                     clear: both;
    //                 }
    //                 .tr-special {
    //                     background: transparent !important;
    //                     border: none !important;
    //                 }
    //                 .tr-special .all-price {
    //                     padding: 4px 4px;
    //                     border-top: 1px solid #ccc;
    //                     border-bottom: 1px solid #ccc;
    //                 }
    //                 .text-red {
    //                     color: red;
    //                 }
    //             </style>
    //         </head>
            
    //         <body onload="window.print();">
    //             <div class="printContainer">
    //             <div class="header">
    //                 <div class="container">
    //                     <div class="logo text-center">
    //                         <a href="#">
    //                             <img src="/images/logo_vendor.png" alt="">
    //                         </a>
    //                     </div>
    //                     <div class="sub-logo text-center">109 Jalan Besar Singapore 208829 &nbsp; Tel: +65 63980900 &nbsp; Fax: +6563980700</div>
    //                     <div class="text-center address">www.jsrdesign.com.sg</div>
    //                 </div>
    //             </div>
    //             <div class="container">
    //                 <div class="row">
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    //                         <div>
    //                             <span class="attn">Attn</span>
    //                             <span>${customer.first_name} ${customer.last_name}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Address</span>
    //                             <span>${customer.address} ${customer.city}</span>
    //                         </div>
    //                     </div>
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-md-push-4 col-lg-4 col-lg-push-4">
    //                         <div>
    //                             <span class="attn">Date</span>
    //                             <span>${getTimePDF()}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Telephone</span>
    //                             <span>${customer.phone}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Ref No</span>
    //                             <span></span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">NRIC</span>
    //                             <span></span>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <div class="marginB5">Email</div>
    //                 <div class="marginB5"><strong>Dear Sir / Madam</strong></div>
    //                 <div class="marginB5"><strong class="text-underline">QUOTATION FOR INTERIOR RENOVATION WORK -  PART 1</strong></div>
    //                 <br>
    //                 <table class="table table-bordered table-hover table-striped">
    //                     <thead>
    //                         <tr>
    //                             <th class="text-center">S/N</th>
    //                             <th>Work Description</th>
    //                             <th class="text-center">Qty Units</th>
    //                             <th class="text-right">Amount</th>
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         ${contentItem}
    //                         <tr class="tr-special" style="background: transparent !important;border: none !important;">
    //                             <td class="text-center">&nbsp;</td>
    //                             <td>
    //                                 <p><strong>Grand Total Amount (After discount)</strong></p>
    //                                 <div>Dollars: ${convertPriceToNumber(price_total)}</div>
    //                             </td>
    //                             <td class="text-center"></td>
    //                             <td class="text-right"><strong class="all-price">$${convertPriceNumber(price_total)}</strong></td>
    //                         </tr>
    //                     </tbody>
    //                 </table>
    //                 <br>
    //                 <div class="row">
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    //                         <div><strong>Yours Sincerely, for ${vendor.detail.name}</strong></div>
    //                         <br>
    //                         <br>
    //                         <br>
    //                         <div class="border-top marginB5"></div>
    //                         <div><strong>Ron Foo (Mobile: 96721804)</strong></div>
    //                         <div><strong>Creative Director</strong></div>
    //                     </div>
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-md-push-4 col-lg-4 col-lg-push-4">
    //                         <div class="text-center"><strong>Agreed & Accepted by:</strong></div>
    //                         <br>
    //                         <br>
    //                         <br>
    //                         <div class="border-top marginB5"></div>
    //                         <div class="text-center"><strong>${customer.first_name} ${customer.last_name}</strong></div>
    //                     </div>
    //                 </div>
    //                 <br>
    //                 <br>
    //             </div>
    //             </div>
    //         </body>
            
    //         </html>`

    //     return windowContent
    // }

    addNewDesignerItem = (e) => {
        e.preventDefault()
        this.setState(prevState => ({
            nb_add: prevState.nb_add + 1
        }))

        let $ = window.$
        $('#modal-add-item-designer').modal('show')
    }

    renderDesignerItems = () => {
        return (
            <div className="block-room">
                <div className="clearfix panen-heading">
                    <div className="pull-left">
                        <div className="big-title">Item</div>
                    </div>
                    {this.props.quoteState == 0 && (
                        <div className="pull-right">
                            <div className="pull-right">
                                <a href="#" onClick={this.addNewDesignerItem.bind(this)} className="bg-blue select">
                                    Add
                                </a>
                            </div>
                        </div>
                    )}
                    
                </div>
                <div className="panen-body">
                    {(this.state.quoteDesignerItems.length) ? this.renderQuoteDesignerItems() : null}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>

                {this.renderDesignerItems()}

                <ModalAddItemDesigner
                    quote={this.props.quote}
                    vendor={this.props.vendor}
                    addNewItem={this.addNewQuoteDesignerItem}
                    itemAdd={this.state.itemAdd}
                    nb_add={this.state.nb_add}
                />
            </div>
        );
    }
}

export default DesignerItemQuote;